// extracted by mini-css-extract-plugin
export default {"avatar":"DefaultAvatar_avatar__0ybBN"};